import React from 'react';
import ReactDOM from 'react-dom';
import { Modal } from './modal';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

export class SupportModal extends React.Component {
  constructor (props) {
    super(props);
    this.closeBehavior = this.closeBehavior.bind(this);
    this.renderBody = this.renderBody.bind(this);
  }

  closeBehavior () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  renderBody () {
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
    return (
      <div className="text-center container-fluid">
        <div className="row">
          <div className="col-xs-12">
            <p>
              <FormattedMessage
                id='inbox.support_modal.have_questions'
                defaultMessage="Have questions? Our world-class support team is here to help. Our regular support hours are Monday - Friday 6am - 6pm PT, and Saturday - Sunday 9am - 6pm PT. If you need help outside of those times, we'll get back to you as soon as we can."
              />
            </p>
            <br />
            <p>
              <b>
                <FormattedMessage
                  id='inbox.support_modal.contact'
                  defaultMessage="Contact our support team {link}"
                  values={{
                    link:
                      <a target="_blank" className="underline" href={`https://support.peerspace.com/hc/${zendeskLocale}/requests/new`}>
                        <FormattedMessage
                          id="inbox.support_modal.here"
                          defaultMessage="here"
                        />
                      </a>
                    }}
                 />
               </b>
            </p>
            <br />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <button onClick={this.closeBehavior} className="btn btn-block btn-primary">
              <FormattedMessage
                id='inbox.support_modal.okay'
                defaultMessage="Okay"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }

  render () {
    return (<Modal
      addCloseIcon={true}
      show
      modalType='standard'
      modalID='support-modal'
      modalSize='sm-size'
      body={this.renderBody()}
      header={ <FormattedMessage id='inbox.support_modal.contact_support' defaultMessage="Contact Peerspace Support" /> }
    />);
  }
}
